import { forwardRef } from 'react';
import { Field, FieldProps } from 'formik';
import { JItem } from '../jformik/jformik.types';
import { InfoCardGroup } from '../../availability';

export const FInfoCardGroup = forwardRef((jItem: JItem, ref) => {
  const { name, label } = jItem;

  return (
    <Field name={name} innerRef>
      {({
        field: { name, value },
        form: { touched, errors, setFieldValue, values, submitCount },
      }: FieldProps) => {
        return <InfoCardGroup key={name} cards={value} />;
      }}
    </Field>
  );
});
